import React, { useState, useRef, useEffect, useContext, useCallback } from 'react'
// import {  useDispatch } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { actlistData, actmore, setisfirsttime } from "../../actions/index";
import Navigationtitle from "../include/Navigationtitle";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import DataService from ".././../services/tutorial.service";
import { getDatabase, ref, remove, push, onValue, set, off, update } from "firebase/database";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faL, faShareNodes } from '@fortawesome/free-solid-svg-icons'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { faExpand } from '@fortawesome/free-solid-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { confirmAlert } from "react-confirm-alert";
import { gif1, gif2, gif3, gif4 } from "../../constants/Images";
import { useSelector, useDispatch } from "react-redux";

export default function AuctionCustomization(match) {
  const dispatch = useDispatch();

  const loginuser = useSelector((state) => state.setUserlog);

  const aucmoredetail = useSelector((state) => state.actmoredata);
  const [aucdetail, setaucdetail] = useState(aucmoredetail);
  const [aucback, setaucback] = useState("");
  const [selectedOption, setSelectedOption] = useState('0');

  const [aucbackbox, setaucbackbox] = useState("");
  const [aucstampbox, setaucstampbox] = useState("");
  const [aucustampbox, setaucustampbox] = useState("");
  const [aucsoldstamp, setaucsoldstamp] = useState("");
  const [aucunsoldstamp, setaucunsoldstamp] = useState("");
  const [aucsponsorbox, setaucsponsorbox] = useState("");
  const [aucbannerbox, setaucbannerbox] = useState("");
  const [aucsponsor, setaucsponsor] = useState("");
  const [aucbanner, setaucbanner] = useState("");
  const [aucaudio, setaucaudio] = useState("");
  const [isimgpop, setisimgpop] = useState(false);
  const [imgpopdata, setimgpopdata] = useState([]);
  const [imgpoptype, setimgpoptype] = useState("");
  const [isbgpop, setisbgpop] = useState(false)
  const [bgdata, setbgdata] = useState([])
  const [isfullbg, setisfullbg] = useState(false)
  const [selectedbgfl, setselectedbgfl] = useState("")
  const [bgfulldata, setbgfulldata] = useState('')

  const [isActive, setActive] = useState(false);
  const [cid, setCid] = useState(loginuser["cid"]);
  const aid = localStorage.getItem("auction_id");
  const updtoken = useSelector((state) => state.updtoken);

  const history = useHistory({ forceRefresh: true });


  const fileInputRefs = useRef(Array.from({ length: 8 }, () => React.createRef()));

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const GIFComponent = () => {
    switch (selectedOption) {
      case '0':
        return <img src={gif1} alt="GIF 1" />;
      // case '1':
      //   return <img src={gif2} alt="GIF 2" />;
      case '2':
        return <img src={gif2} alt="GIF 3" />;
      case '3':
        return <img src={gif3} alt="GIF 4" />;
      case '4':
        return <img src={gif4} alt="GIF 4" />;
      default:
        return null;
    }
  };
  useEffect(() => {
    //  console.log('auc more detail')
    //  console.log(aucdetail)
    //  console.log(aucmoredetail)
    if (aucmoredetail.more && aucmoredetail.more.length > 0) {
      console.log(aucmoredetail.more)
      if (aucmoredetail.more[0].bg != "" && aucmoredetail.more[0].bg != null) {
        // //  console.log('auc more data bg image...!!')
        setaucbackbox(aucmoredetail.fpath + aucmoredetail.more[0].bg)
      }

      if (aucmoredetail.more[0].sstamp != "" && aucmoredetail.more[0].sstamp != null) {
        setaucstampbox(aucmoredetail.fpath + aucmoredetail.more[0].sstamp)
      }
      if (aucmoredetail.more[0].fireworks != "" && aucmoredetail.more[0].fireworks != null) {
        setSelectedOption(aucmoredetail.more[0].fireworks)
      }
      if (aucmoredetail.more[0].usstamp != "" && aucmoredetail.more[0].usstamp != null) {
        setaucustampbox(aucmoredetail.fpath + aucmoredetail.more[0].usstamp)
      }
    }
  }, [aucmoredetail])

  useEffect(() => {
    window.scrollTo(0, 0);
    const isFirstMount = localStorage.getItem('isFirstMount');
    //  console.log('isFirstMount')
    //  console.log(isFirstMount)
    if (!isFirstMount) {
      //  console.log('setting false')
      localStorage.setItem('isFirstMount', false);
    } else {
      //  console.log('going back....')

      localStorage.removeItem('isFirstMount');
      history.push('/auction-detail');
    }
  }, [history]);

  const handleFileChange = (e, t) => {
    const file = e.target.files[0];
    if (t == "1") {
      setaucback(file)
    }
    else if (t == "2") {
      setaucsoldstamp(file)
    }
    else if (t == "3") {
      setaucunsoldstamp(file)
    }
    else if (t == "4") {
      setaucsponsor(file)
    }
    else if (t == "5") {
      setaucbanner(file)
    }
    else if (t == "6") {
      setaucaudio(file)
    }
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (t == "1") {
          setaucbackbox(event.target.result);
        }
        else if (t == "2") {
          setaucstampbox(event.target.result)
        }
        else if (t == "3") {
          setaucustampbox(event.target.result)
        }
        else if (t == "4") {
          setaucsponsorbox(event.target.result)
        }
        else if (t == "5") {
          setaucbannerbox(event.target.result)
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const removefile = async (imgpoptype) => {
    if (imgpoptype == '3' || imgpoptype == '4' || imgpoptype == '5') {
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
        },
      };
      var vals = {}

      if (imgpoptype == '3') {
        vals.fltyp = 'bg';
      }
      else if (imgpoptype == '4') {
        vals.fltyp = 'sstamp';
      }
      else if (imgpoptype == '5') {
        vals.fltyp = 'usstamp';
      }
      await DataService.delfiles(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);

          if (response.success == true) {
            setisimgpop(false)
            if (imgpoptype == '3') {
              setaucdetail(detail => ({
                ...detail,
                more: [{ ...detail.more[0], bg: "" }]
              }))
            }
            else if (imgpoptype == '4') {
              setaucdetail(detail => ({
                ...detail,
                more: [{ ...detail.more[0], sstamp: "" }]
              }))
            }
            else if (imgpoptype == '5') {
              setaucdetail(detail => ({
                ...detail,
                more: [{ ...detail.more[0], usstamp: "" }]
              }))
            }
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });

          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          //  console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    }
    else if (imgpoptype == '2') {
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
        },
      };
      var vals = {}
      vals.i = imgpopdata.spnid

      await DataService.delspn(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);
          if (response.success == true) {
            const db = getDatabase();
            set(ref(db, 'auction/info/' + aid), {
              "type": "1", "upd": "6", 'id': aid, "detail": {
                "typ": 14,
                "upd": 2,
                "val": imgpopdata.spnid,
              }, "tkn": updtoken
            });
            setisimgpop(false)
            setaucdetail(detail => ({
              ...detail,
              spn: detail.spn.filter((sp) => sp.spnid != imgpopdata.spnid)
            }))
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });

          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          //  console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    }
    else if (imgpoptype == '1') {
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
        },
      };
      var vals = {}
      vals.i = imgpopdata.bnrid

      await DataService.delbnr(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);
          if (response.success == true) {
            const db = getDatabase()
            set(ref(db, 'auction/info/' + aid), {
              "type": "1", "upd": "6", 'id': aid, "detail": {
                "typ": 15,
                "upd": 2,
                "val": { id: imgpopdata.bnrid },
              }, "tkn": updtoken
            });
            setisimgpop(false)
            setaucdetail(detail => ({
              ...detail,
              bnr: detail.bnr.filter((bn) => bn.bnrid != imgpopdata.bnrid)
            }))
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });

          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          //  console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    }
  }

  const removeuploads = async (t) => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    var vals = {}
    if (t == '1') {
      vals.fltyp = 'bg';
    }
    else if (t == '2') {
      vals.fltyp = 'sstamp';
    }
    else if (t == '3') {
      vals.fltyp = 'usstamp';
    }
    await DataService.delfiles(vals, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);

        if (response.success == true) {
          setisimgpop(false)
          if (t == '1') {
            setaucbackbox("")
            setaucdetail(detail => ({
              ...detail,
              more: [{ ...detail.more[0], bg: "" }]
            }))
            const db = getDatabase();
            set(ref(db, 'auction/info/' + aid), {
              "type": "1", "upd": "6", 'id': aid, "detail": {
                "typ": 13,
                "upd": 2,
                "val": "",
              }, "tkn": updtoken
            });
          }
          else if (t == '2') {
            setaucstampbox("")
            setaucdetail(detail => ({
              ...detail,
              more: [{ ...detail.more[0], sstamp: "" }]
            }))
          }
          else if (t == '3') {
            setaucustampbox("")
            setaucdetail(detail => ({
              ...detail,
              more: [{ ...detail.more[0], usstamp: "" }]
            }))
          }
          toast.success("Removed !!", {
            theme: "colored",
            position: "bottom-center",
          });

        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  }
  const delfile = (t) => {
    confirmAlert({
      message: "Are you sure delete this record !",
      buttons: [
        {
          label: "Yes",
          onClick: () => removeuploads(t),
        },
        {
          label: "No",
          // onClick: () => del(id, 0),
        },
      ],
    });
  };
  const del = useCallback(
    async (vl, status) => {
      if (status == 1) {
        setActive(true);

        var hdr = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: JSON.stringify([{ cid: loginuser["cid"], token: loginuser["token"] }]),
          },
        };

        await DataService.deleteAuction({ aid: encode(vl) }, hdr)
          .then((res) => {
            let response = res.data;
            if (response.success == true) {
              toast.success(response.msg, {
                theme: "dark",
                position: "bottom-center",
              });

              const updateitem = getpageData.responsedata.list.filter(
                (ele, ind) => {
                  if (ele.aid != vl) {
                    return ele;
                  }
                }
              );
              let responsedata = {
                responsedata: {
                  path: getpageData.responsedata.path,
                  cid: cid,
                  list: updateitem,
                },
              };
              dispatch(actlistData(responsedata));
              history.push(BASE_PATH + "my-auction");
              // const updateitem = data.list.filter((ele, ind) => {
              //   return ele.aid != vl;
              // });
              // data.list = updateitem;
              // setData(data);
            } else {
              toast.error(response.msg, {
                theme: "colored",
                position: "bottom-center",
              });
            }

            setActive(false);
          })
          .catch(() => {
            //  console.log("Not valid");
            toast.error("Not valid Server Error", {
              theme: "colored",
              position: "bottom-center",
            });
            setActive(false);
          });
      }
    },
    []
  );
  function showfullbg(ele) {
    setisfullbg(true)
    setbgfulldata(ele)
  }
  function handleDivClick(fl) {
    setselectedbgfl(fl)
  }
  const setfireworkeffect = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    var vals = {}
    // vals.fltyp = 'bg';
    vals.fireworks = selectedOption
    await DataService.setfirework(vals, hdr)
      .then((res) => {
        let response = res.data;
        //  console.log('firework response')
        //  console.log(response)
        //  console.log(vals)
        toast.dismiss(toastContainerId);
        if (response.success == true) {
          setaucdetail(detail => ({
            ...detail,
            more: [{ ...detail.more[0], fireworks: selectedOption }]
          }))

          var auccopy = aucdetail
          auccopy.more[0].fireworks = selectedOption
          dispatch(actmore(auccopy));
          // const db = getDatabase();
          // set(ref(db, 'auction/info/' + aid), {
          //   "type": "1", "upd": "6", 'id': aid, "detail": {
          //     "typ": 13,
          //     "upd": 1,
          //     "val": { img: response.data.newentry.logo },
          //   }, "tkn": updtoken
          // });
          // setisbgpop(false)
          // setselectedbgfl("")

          toast.success("Effect set !!", {
            theme: "colored",
            position: "bottom-center",
          });
          // setaucbackbox(bgdata.path + selectedbgfl)
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });

  }
  const setbg = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    var vals = {}
    vals.fltyp = 'bg';
    vals.fl = selectedbgfl
    await DataService.setbg(vals, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        if (response.success == true) {
          const db = getDatabase();
          set(ref(db, 'auction/info/' + aid), {
            "type": "1", "upd": "6", 'id': aid, "detail": {
              "typ": 13,
              "upd": 1,
              "val": { img: response.data.newentry.logo },
            }, "tkn": updtoken
          });
          setisbgpop(false)
          setselectedbgfl("")

          toast.success("Background set !!", {
            theme: "colored",
            position: "bottom-center",
          });
          setaucbackbox(bgdata.path + selectedbgfl)
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });

  }
  const banneradd = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    const formData = new FormData();
    formData.append("bnrimg", aucbanner);

    await DataService.addbanner(formData, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        // //  console.log(response)
        if (response.success == true) {
          const db = getDatabase()
          set(ref(db, 'auction/info/' + aid), {
            "type": "1", "upd": "6", 'id': aid, "detail": {
              "typ": 15,
              "upd": 1,
              "val": response.data.newentry,
            }, "tkn": updtoken
          });
          setaucbannerbox("")
          fileInputRefs.current.forEach((ref) => {
            if (ref.current) {
              ref.current.value = '';
            }
          });
          setaucdetail(prev => ({
            ...prev,
            bnr: [...prev.bnr, response.data.newentry]
          }))
          // //  console.log("setted")
          toast.success("Banner Added !!", {
            theme: "colored",
            position: "bottom-center",
          });

          setaucbanner("")
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  }
  const sponsoradd = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    const formData = new FormData();
    formData.append("splogo", aucsponsor);
    await DataService.addsponsor(formData, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        // //  console.log(response)
        if (response.success == true) {
          //  console.log('sponsor add response....!!')
          //  console.log(response.success)
          const db = getDatabase();
          //  console.log('sponsor add response ddd....!!')

          set(ref(db, 'auction/info/' + aid), {
            "type": "1", "upd": "6", 'id': aid, "detail": {
              "typ": 14,
              "upd": 1,
              "val": response.data.newentry,
            }, "tkn": updtoken
          });
          // //  console.log("setted")
          //  console.log('sponsor add response eee....!!')

          setaucsponsorbox("")
          fileInputRefs.current.forEach((ref) => {
            if (ref.current) {
              ref.current.value = '';
            }
          });
          toast.success("Sponsor Added !!", {
            theme: "colored",
            position: "bottom-center",
          });
          //  console.log('sponsor add response 22222....!!')

          setaucdetail(prev => ({
            ...prev,
            spn: [...prev.spn, response.data.newentry]
          }))

          setaucsponsor("")
        } else {
          //  console.log('sponsor add response 33333....!!')

          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }
        //  console.log('sponsor add response. 444...!!')

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  }
  const chooseback = async () => {
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
      },
    };

    await DataService.bglist({}, hdr)
      .then((res) => {
        let response = res.data;
        if (response.success == true) {
          setbgdata(response.data)

        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
    setisbgpop(!isbgpop)

  }
  const uploadfiles = async (typ) => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    const formData = new FormData();
    if (typ == 'bg') {
      // if (aucbackbox == "") {

      //   formData.append("fl", aucback);
      // } else {
      //   alert('This background is already set !!')
      //   toast.dismiss(toastContainerId); // Dismiss the toast message here

      //   return 0
      // }
      formData.append("fl", aucback);

      const fileSizeKB = Math.round(aucback.size / 1024); // Convert bytes to kilobytes
      const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
      if (fileSizeMB > 1.25) {
        alert('File size must be less than 1.25Mb')
        toast.dismiss(toastContainerId);
        return 0
      }

    }
    else if (typ == 'sstamp') {
      formData.append("fl", aucsoldstamp);
      const fileSizeKB = Math.round(aucsoldstamp.size / 1024); // Convert bytes to kilobytes
      const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
      if (fileSizeMB > 1.25) {
        alert('File size must be less than 1.25Mb')
        toast.dismiss(toastContainerId);
        return 0
      }


    }
    else if (typ == 'usstamp') {
      formData.append("fl", aucunsoldstamp);
      const fileSizeKB = Math.round(aucunsoldstamp.size / 1024); // Convert bytes to kilobytes
      const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
      if (fileSizeMB > 1.25) {
        alert('File size must be less than 1.25Mb')
        toast.dismiss(toastContainerId);
        return 0
      }
    }
    else if (typ == "audio") {
      formData.append("fl", aucaudio);
      const fileSizeKB = Math.round(aucaudio.size / 1024); // Convert bytes to kilobytes
      const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
      if (fileSizeMB > 1.25) {
        alert('File size must be less than 1.25Mb')
        toast.dismiss(toastContainerId);
        return 0
      }
    }


    formData.append("fltyp", typ);
    await DataService.addfiles(formData, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        if (response.success == true) {
          if (typ == 'bg') {
            setaucdetail(detail => ({
              ...detail,
              more: [{ ...detail.more[0], bg: response.data.newentry.logo }]
            }))
            setaucback("")
            const db = getDatabase();
            set(ref(db, 'auction/info/' + aid), {
              "type": "1", "upd": "6", 'id': aid, "detail": {
                "typ": 13,
                "upd": 1,
                "val": { img: response.data.newentry.logo },
              }, "tkn": updtoken
            });

          }
          else if (typ == 'sstamp') {

            setaucdetail(detail => ({
              ...detail,
              more: [{ ...detail.more[0], sstamp: response.data.newentry.logo }]
            }))
            setaucsoldstamp("")
          }
          else if (typ == 'usstamp') {
            setaucdetail(detail => ({
              ...detail,
              more: [{ ...detail.more[0], usstamp: response.data.newentry.logo }]
            }))
            setaucunsoldstamp("")
          }
          else if (typ == "audio") {
            // setaucdetail(detail => ({
            //   ...detail,
            //   more: [{ ...detail.more[0], audio: response.data.newentry.fl }]
            // }))
            setaucaudio("")
          }
          // //  console.log("setted")
          fileInputRefs.current.forEach((ref) => {
            if (ref.current) {
              ref.current.value = '';
            }
          });
          toast.success("Added !!", {
            theme: "colored",
            position: "bottom-center",
          });

          // setaucdetail(prev => ({
          //   ...prev,
          //   spn: [...prev.spn, response.data.newentry]
          // }))

        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  }
  function setimagepopup(item, t) {
    setisimgpop(true)
    setimgpopdata(item)
    setimgpoptype(t)
  }
  return (
    <div>
      <Navigationtitle data={match} />
      {
        isbgpop &&
        <div id='bgdiv' className="bgdiv">


          <div className="bgpop themeboxmain">
            <div className='headsticky'>
              <h3>Select Background<FontAwesomeIcon onClick={() => { isfullbg ? setisfullbg(false) : setisbgpop(false) }} style={{ position: "relative", float: "right", cursor: 'pointer' }} icon={faXmark} /> </h3>
            </div>
            {!isfullbg && <div className="bgpopmain">
              {bgdata.list.map((ele) => {
                return (
                  <div key={ele.fl} className={`bgimgdiv ${selectedbgfl == ele.fl ? 'selbg' : ''}`} onClick={() => handleDivClick(ele.fl)}>
                    <FontAwesomeIcon onClick={() => showfullbg(ele)} className='imgzoom' icon={faExpand} />
                    <img src={bgdata.path + ele.fl} alt="" />
                    {selectedbgfl == ele.fl && <button onClick={() => setbg()} className='bgsetbtn'>set</button>}

                  </div>
                )
              })}
            </div>}
            {isfullbg &&
              <div className="bgpopmain">
                <img className='bgfullimg' src={bgdata.path + bgfulldata.fl} alt="background" />
              </div>
            }
          </div>
        </div>
      }
      {isimgpop && <>
        <div className="impopbg"></div>
        <div className="impopmain">
          <div>
            <h3>
              {imgpoptype == "2" && "Sponsor"}
              {imgpoptype == "1" && "Banner"}
              <FontAwesomeIcon onClick={() => setisimgpop(false)} style={{ padding: ".5rem", cursor: "pointer", position: "relative", float: "right" }} icon={faXmark} />
            </h3>

          </div>
          <div>
            {imgpoptype == "2" && <img src={aucdetail.spath + imgpopdata.logo} alt="" />}
            {imgpoptype == "1" && <img src={aucdetail.bpath + imgpopdata.img} alt="" />}
            {imgpoptype == "3" && <img src={aucdetail.fpath + imgpopdata} alt="" />}
            {imgpoptype == "4" && <img src={aucdetail.fpath + imgpopdata} alt="" />}
            {imgpoptype == "5" && <img src={aucdetail.fpath + imgpopdata} alt="" />}


          </div>
          <div onClick={() => removefile(imgpoptype)} style={{ padding: ".5rem", cursor: "pointer", position: "relative", float: "right" }} > <FontAwesomeIcon style={{ marginRight: ".5rem" }} icon={faTrash} />Remove</div>
        </div>

      </>}

      <div className='auctionHead'>
        {aucdetail != "" && aucdetail.detail.auctionname}
      </div>
      {/* <div className='customizationHead'>CUSTOMIZATION</div> */}
      <div className="myflex">
        <div className="auction-details-card-container2 acardcont3 themecustom">
          <div>
            Customize Full Theme 
          </div>
          <Link to={'auction-customization2'}>   <button className="mydesbtn" >Customize</button></Link>        </div>
      </div>
      <div className="myflex">

        <div className="auction-details-card-container2 acardcont3 uploaddiv">
          <div className="striphead"><h3>Custom Uploads</h3></div>
          <span className="imglimit">Please upload less than 1.25 Mb image</span>
          <div className="fileflex">

            <div className="uploadbox">
              <div className="newstrip">
                {aucdetail != "" && aucdetail.more.length > 0 && aucdetail.more[0].bg != "" && aucdetail.more[0].bg != null && aucback == "" &&
                  <div className="filebtns">
                    <div> <FontAwesomeIcon onClick={() => { document.getElementById('bg').click(); }} style={{ cursor: 'pointer' }} icon={faPenToSquare} /></div>
                    <div> <FontAwesomeIcon onClick={() => delfile('1')} style={{ cursor: 'pointer' }} icon={faTrash} /></div>
                  </div>
                }
                <div>
                  <label className="updlbl" htmlFor="">Background</label>
                </div>
                <div style={{ cursor: "pointer" }} className="stripmainbox" onClick={() => { document.getElementById('bg').click(); }}>
                  {aucbackbox && <img className="boximg" src={aucbackbox} alt="" />}

                  <label htmlFor="" style={{ cursor: "pointer" }}>+Add</label>
                  <input className="choosefile" ref={fileInputRefs.current[3]} onChange={(e) => handleFileChange(e, "1")} type="file" id="bg" />
                </div>
                <label onClick={() => chooseback()} className="sugbg" style={{ fontSize: '1.2rem', cursor: 'pointer' }} htmlFor="">Suggested Backgrounds</label>


                {aucback && <div class=""><button onClick={() => uploadfiles('bg')} className="updbtnsnew">Upload</button></div>}

              </div>

            </div>
            <div className="uploadbox">
              <div className="newstrip">
                {aucdetail != "" && aucdetail.more.length > 0 && aucdetail.more[0].sstamp != "" && aucdetail.more[0].sstamp != null && aucsoldstamp == "" &&
                  <div className="filebtns">
                    <div> <FontAwesomeIcon onClick={() => { document.getElementById('sstamp').click(); }} style={{ cursor: 'pointer' }} icon={faPenToSquare} /></div>
                    <div> <FontAwesomeIcon onClick={() => delfile('2')} style={{ cursor: 'pointer' }} icon={faTrash} /></div>
                  </div>
                }
                <div>
                  <label className="updlbl" htmlFor="">Sold Stamp</label>
                </div>
                <div style={{ cursor: "pointer" }} className="stripmainbox" onClick={() => { document.getElementById('sstamp').click(); }}>
                  {aucstampbox && <img className="boximg" src={aucstampbox} alt="" />}

                  <label htmlFor="" style={{ cursor: "pointer" }}>+Add</label>
                  <input className="choosefile" ref={fileInputRefs.current[4]} onChange={(e) => handleFileChange(e, "2")} type="file" id="sstamp" />

                </div>

                {aucsoldstamp && <div class=""><button onClick={() => uploadfiles('sstamp')} className="updbtnsnew">Upload</button></div>}

              </div>

            </div>
          </div>


          <div className="fileflex">
            <div className="uploadbox">
              <div className="newstrip">
                {aucdetail != "" && aucdetail.more.length > 0 && (aucdetail.more[0].usstamp != "" && aucdetail.more[0].usstamp != null) && aucunsoldstamp == "" &&
                  <div className="filebtns">
                    <div> <FontAwesomeIcon onClick={() => { document.getElementById('usstamp').click(); }} style={{ cursor: 'pointer' }} icon={faPenToSquare} /></div>
                    <div> <FontAwesomeIcon onClick={() => delfile('3')} style={{ cursor: 'pointer' }} icon={faTrash} /></div>
                  </div>
                }
                <div>
                  <label className="updlbl" style={{ cursor: "pointer" }} htmlFor="">Unsold Stamp</label>
                </div>
                <div style={{ cursor: "pointer" }} className="stripmainbox" onClick={() => { document.getElementById('usstamp').click(); }}>
                  {aucustampbox && <img className="boximg" src={aucustampbox} alt="" />}

                  <label htmlFor="">+Add</label>
                  <input className="choosefile" ref={fileInputRefs.current[5]} onChange={(e) => handleFileChange(e, "3")} type="file" id="usstamp" />

                </div>

                {aucunsoldstamp && <div class=""><button onClick={() => uploadfiles('usstamp')} className="updbtnsnew">Upload</button></div>}

              </div>

            </div>
            <div className="uploadbox">
              <div className="newstrip">
                
                <div>
                  <label className="updlbl" style={{ cursor: "pointer" }} htmlFor="">Audio</label>
                </div>
                <div style={{ cursor: "pointer" }} className="stripmainbox" onClick={() => { document.getElementById('audio').click(); }}>
                  <label htmlFor="">+Add</label>
                  <input className="choosefile" ref={fileInputRefs.current[6]} onChange={(e) => handleFileChange(e, "6")} type="file" id="audio" />

                </div>

                {aucaudio && <div class=""><button onClick={() => uploadfiles('audio')} className="updbtnsnew">Upload</button></div>}

              </div>

            </div>
          </div>
        </div>
        <div className="auction-details-card-container2 acardcont3 spnbndiv">
          <div className="striphead"><h3>Sponsors and Banners</h3></div>
          <div className="bnrsnew">
            <div className="spnbninp">
              <div className="new2strip">
                <div>

                  <label htmlFor="">Sponsor</label>
                </div>
                <div style={{ cursor: "pointer" }} className="spnbnbox" onClick={() => { document.getElementById('spn').click(); }}>
                  {aucsponsorbox && <img className="boximg" src={aucsponsorbox} alt="" />}

                  <label style={{ cursor: "pointer" }} htmlFor="">+Add</label>

                  <div className="stripmain" style={{ display: 'none' }}>
                    <input className="choosefile" ref={fileInputRefs.current[1]} onChange={(e) => handleFileChange(e, "4")} type="file" id="spn" />
                  </div>
                </div>

                {aucsponsor && <div class=""><button onClick={() => sponsoradd()} className="updbtnsnew">Upload</button></div>}

              </div>
            </div>
            <div className="spnbnimg">
              {(aucdetail != "" && aucdetail.spn.length > 0) ? aucdetail.spn.map((item) => {
                return (
                  <>
                    <div>
                      <img onClick={() => setimagepopup(item, "2")} className="" src={aucdetail.spath + item.logo} alt="" />
                    </div>
                  </>
                )
              })
                : <><div className="spnbnmsg"> Haven't Uploaded Sponsor !!</div></>

              }
            </div>
          </div>
          <div className="bnrsnew">
            <div className="spnbninp">

              <div className="new2strip">
                <div>
                  <label htmlFor="">Banner</label>

                </div>
                <div style={{ cursor: "pointer" }} className="spnbnbox" onClick={() => { document.getElementById('bnr').click(); }}>
                  {aucbannerbox && <img className="boximg" src={aucbannerbox} alt="" />}

                  <label style={{ cursor: "pointer" }} htmlFor="">+Add</label>

                  <div className="stripmain" style={{ display: 'none' }}>

                    <input className="choosefile" ref={fileInputRefs.current[2]} onChange={(e) => handleFileChange(e, "5")} type="file" id="bnr" />

                  </div>
                </div>
                {aucbanner && <div class=""><button onClick={() => banneradd()} className="updbtnsnew">Upload</button></div>}
              </div>
            </div>
            <div className="spnbnimg">
              {(aucdetail != "" && aucdetail.bnr.length > 0) ? aucdetail.bnr.map((item) => {
                return (
                  <>
                    <div>
                      <img onClick={() => setimagepopup(item, "1")} className="" src={aucdetail.bpath + item.img} alt="" />
                    </div>
                  </>
                )
              })
                : <><div className="spnbnmsg"> Haven't Uploaded Banner !!</div></>
              }
            </div>
          </div>



        </div>
      </div>
      <div className="myflex">
        <div className="auction-details-card-container2 acardcont3 uploaddiv fireworkdiv">
          <div className="striphead">
            <h3>Sold Effects options</h3>
          </div>

          <div className='gifshow2'>
            <button onClick={() => setSelectedOption("1")} className={`gifbuttons ${selectedOption == "1" && 'gifbuttonelected'}`}>No</button>
            <button onClick={() => setSelectedOption("2")} className={`gifbuttons ${selectedOption == "2" && 'gifbuttonelected'}`}>1</button>
            <button onClick={() => setSelectedOption("0")} className={`gifbuttons ${selectedOption == "0" && 'gifbuttonelected'}`}>2</button>
            <button onClick={() => setSelectedOption("3")} className={`gifbuttons ${selectedOption == "3" && 'gifbuttonelected'}`}>3</button>
            <button onClick={() => setSelectedOption("4")} className={`gifbuttons ${selectedOption == "4" && 'gifbuttonelected'}`}>4</button>
            <button className='mydesbtn fireworksetbutton' onClick={() => setfireworkeffect()}>Set</button>

          </div>
          <div className='gifshow'>
            <GIFComponent />
          </div>
          {/* <select className='fireworksetbutton' value={selectedOption} onChange={handleOptionChange}>
          <option value="1">No Firework</option>
          <option value="2">Firework 1</option>
          <option value="0">Firework 2</option>
          <option value="3">Firework 3</option>
          <option value="4">Firework 4</option>
        </select> */}
          {/* <button className='mydesbtn fireworksetbutton' onClick={()=>setfireworkeffect()}>Set</button> */}
        </div>
        {/* <div className="auction-details-card-container2 acardcont3 uploaddiv">
        <div className="striphead">
          <h3>Sold Effect</h3>
        </div>
        
      </div> */}
      </div>
      <div className="myflex">
        <div className="auction-details-card-container2 acardcont3 uploaddiv fireworkdiv">
          <div className="striphead">
            <h3>Audio Upload</h3>
          </div>
          <div className='audioflex'>
            <input type="file" />
            <button className='mydesbtn fireworksetbutton' >Soon</button>
          </div>
        </div>
      </div>
    </div>
  )
}
